<style lang="scss" scoped>
.col-form-label {
  font-weight: bold;
  text-align: right;
  padding-top: 0.1rem;
  font-size: 0.8rem;
}
</style>

<template>
  <div class="card">
    <div class="card-header" :class="headerClass">
      <slot name="title"></slot>
    </div>
    <div class="card-body">
      <form action @submit.prevent="persist">
        <div
          v-for="(attribute, index) in data"
          :key="index"
          v-if="!attribute.hideEmpty || attribute.value"
          class="form-group row"
          :style="attribute.customStyle"
        >
          <div v-if="attribute.hr" class="col-12">
            <hr />
          </div>
          <col-label
            v-if="attribute.label && !attribute.hidden"
            :for="attribute.name"
            >{{ attribute.label }}</col-label
          >
          <div :class="colSize">
            <component
              v-if="!attribute.hidden"
              :is="attribute.component"
              v-model="attribute.value"
              :attribute="attribute"
              :disabled="attribute.disabled"
              :key="status"
            ></component>
          </div>
          <div :class="[colStyle === 'fill' ? '' : 'col-1']"></div>
        </div>
        <div v-if="!staticMode" class="row">
          <div :class="[colStyle === 'fill' ? '' : 'col-3']"></div>
          <div :class="[colStyle === 'fill' ? 'col-12' : 'col-8']">
            <v-button
              type="submit"
              class="btn-primary float-right"
              :working="working"
              >Speichern</v-button
            >
            <span v-if="errorMessage !== null" class="text-error">{{
              errorMessage
            }}</span>
          </div>
        </div>
        <div :class="[colStyle === 'fill' ? '' : 'col-1']"></div>
      </form>
      <slot></slot>
    </div>
  </div>
</template>

<script lang="babel">
import { debounce } from "lodash";

import Multiselect from 'vue-multiselect';
import SexSelector from "@/components/selector/SexSelector.vue";
import OptionSelector from "@/components/selector/OptionSelector.vue";
import MultiOptionSelector from "@/components/selector/MultiOptionSelector.vue";
import BirthdaySelector from "@/components/selector/BirthdaySelector.vue";
import SliderSelector from "@/components/selector/SliderSelector.vue";
import InputSelector from "@/components/selector/InputSelector.vue";
import TextareaSelector from "@/components/selector/TextareaSelector.vue";
import CheckboxSelector from "@/components/selector/CheckboxSelector.vue";
import ImageSelector from '@/components/selector/ImageSelector.vue';
import MultiSliderSelector from "@/components/selector/MultiSliderSelector.vue";
import FakeSelector from "@/components/selector/FakeSelector.vue";
import MessagePool from "@/components/selector/MessagePool.vue";
import DropdownResourceSelector from '@/components/selector/DropdownResourceSelector';
import DropdownProfileSelector from '@/components/selector/DropdownProfileSelector';
import PasswordResetSelector from '@/components/selector/PasswordResetSelector';
import CodeSelector from '@/components/selector/CodeSelector';
import DateTimeSelector from '@/components/selector/DateTimeSelector';
import StaticText from '@/components/selector/StaticText';
import DefaultValueSwitchSelector from '@/components/selector/DefaultValueSwitchSelector';
import MessageElementsSelector from '@/components/selector/MessageElementsSelector';
import SelectSelector from '@/components/selector/SelectSelector';
import DateSelector from '@/components/selector/DateSelector';
import PostcodeSelector from '@/components/selector/PostcodeSelector';
import DropdownSelector from '@/components/DropdownSelector.vue';
import DateRangeSliderSelector from '@/components/selector/DateRangeSliderSelector.vue';
import RoleSelector from '@/components/selector/RoleSelector.vue';
import PermissionSelector from '@/components/selector/PermissionSelector.vue';
import UserVerified from '@/components/selector/UserVerified.vue';
import MultiInputSelector from "@/components/selector/MultiInputSelector.vue";
import InputWithPrefixSelector from "@/components/selector/InputWithPrefixSelector.vue";
import TelegramConnection from '@/components/selector/TelegramConnection.vue';
import UserActivitySelector from '@/components/selector/UserActivitySelector.vue';
import WYSIWYGSelector from "@/components/selector/WYSIWYGSelector.vue";

export default {
    components: {
      Multiselect,
      SexSelector,
      SliderSelector,
      InputSelector,
      TextareaSelector,
      OptionSelector,
      MultiOptionSelector,
      BirthdaySelector,
      CheckboxSelector,
      ImageSelector,
      MultiSliderSelector,
      FakeSelector,
      MessagePool,
      DropdownResourceSelector,
      PasswordResetSelector,
      CodeSelector,
      DateTimeSelector,
      StaticText,
      DefaultValueSwitchSelector,
      MessageElementsSelector,
      SelectSelector,
      DateSelector,
      PostcodeSelector,
      DropdownProfileSelector,
      DropdownSelector,
      DateRangeSliderSelector,
      RoleSelector,
      PermissionSelector,
      UserVerified,
      MultiInputSelector,
      InputWithPrefixSelector,
      TelegramConnection,
      UserActivitySelector,
      WYSIWYGSelector,
    },
    data () {
      return {
        data: [],
        working: false,
        errorMessage: null,
        filterChangedDebounced: debounce(this.emitFilterChanged, 300),
        status: true
      };
    },
    async created() {
      await this.$store.dispatch(`${this.resource}/meta`);
      this.attributes.forEach((attribute) => {
        if (this.editing && !attribute.infoText || (this.createMode && this.original)) {
          this.$set(attribute, 'value', this.content(this.original, attribute.name));
        } else {
          this.$set(attribute, 'value', attribute.value === undefined ? null : attribute.value);
        }
        this.$set(attribute, 'disabled', attribute.disabled === undefined ? false : attribute.disabled);
        this.$set(attribute, 'isFilter', attribute.isFilter === undefined ? false : attribute.isFilter);
        this.$set(attribute, 'updatable', attribute.updatable === undefined ? false : attribute.updatable);
        this.$set(attribute, 'hideable', attribute.hideable === undefined ? false : attribute.hideable);
        this.$set(attribute, 'customStyle', attribute.customStyle === undefined ? "" : attribute.customStyle);
        if (attribute.hideable){
          this.$set(attribute, 'hideEvent', attribute.hideEvent === undefined ? "" : attribute.hideEvent);
          this.$set(attribute, 'customStyle', '');
          this.$bus.$on('checkbox-'+attribute.hideEvent+'-clicked', (status) => {
            this.data.forEach((attr) => {
              if(attribute.name === attr.name){
                if (attribute.reverseHide) {
                  attr.customStyle = status ? '': 'display:none;';
                } else {
                  attr.customStyle = status ? 'display:none;': '';
                }
              }
            });
            if (attribute.reload) {
              this.status = status;
            }
          });
        }
        this.$set(attribute, 'hideEmpty', attribute.hideEmpty === undefined ? false : attribute.hideEmpty);
        this.$set(attribute, 'errors', []);
        this.$set(attribute, 'nestedErrors', {});
        this.$set(attribute, 'type', this.type(attribute.type));
        this.$set(attribute, 'component', this.component(attribute.type));
        this.$set(attribute, 'options', this.$store.getters[`${this.resource}/options`](attribute.name));
        this.data.push(Object.assign({}, attribute));
      });
    },
    props: {
      'resource': {
        type: String,
        required: true,
      },
      'resourceName': {
        type: String,
        required: false,
        default: 'Artikel'
      },
      'notification': {
        type: String,
        required: false,
        default: null
      },
      'attributes': {
        required: true,
        type: Array,
      },
      'original': {
        required: false,
        type: Object,
        default: null,
      },
      'staticMode': {
        required: false,
        type: Boolean,
        default: false,
      },
      'withFiles': {
        required: false,
        type: Boolean,
        default: false
      },
      'createMode': {
        required: false,
        type: Boolean,
        default: false
      },
      'headerClass': {
        required: false,
        type: String,
        default: ''
      },
      'colStyle': {
        type: String,
        required: false,
        default: null
      },
    },
    methods: {
      persist() {
        const data = this.buildFormData();
        const action = this.editing ? `${this.resource}/update` : `${this.resource}/create`;
        const url = this.editing ? this.original.update_url : this.createUrl;
        this.working = true;
        this.clearErrors();

        this.$store.dispatch(action, {
          url,
          data,
        }).then(({ data }) => {
          let redirectUrl = null;
          if (!this.editing) {
            if (this.$store.getters[`${this.resource}/createRedirectUrl`] !== null) {
              redirectUrl = this.$store.getters[`${this.resource}/createRedirectUrl`];
            } else if (data.update_page_url !== undefined) {
              redirectUrl = (new URL(data.update_page_url)).pathname;
            }
          } else {
            if (this.$store.getters[`${this.resource}/updateRedirectUrl`] !== null) {
              redirectUrl = this.$store.getters[`${this.resource}/updateRedirectUrl`];
            }
          }

          if (redirectUrl) {
            if (!this.$router) {
              window.location.href = redirectUrl;
            } else {
              this.$router.push(redirectUrl);
            }
          }

          this.working = false;
          this.$bus.$emit('resource-persisted', data);
          this.$emit('resource-persisted', data);

          let notifyText = this.notification
            ? this.notification
            : `${this.resourceName} wurde gespeichert`;

          this.$notify({
            title: notifyText,
            type: "success"
          });
        }).catch(({response}) => {
          this.working = false;

          if (response === undefined) {
            console.warn(`${action} is not a known vuex action`);
            return;
          }

          this.errorMessage = response.data.message;

          const errorKeys = Object.keys(response.data.errors);
          const dataKeys = Object.keys(this.data);
          errorKeys.forEach((errorKey) => {
            dataKeys.forEach((dataKey) => {
              let nestedErrorKeys = errorKey.split(".");

              if (this.data[dataKey].name === errorKey) {
                this.data[dataKey].errors = response.data.errors[errorKey];
              } else if (this.data[dataKey].name === nestedErrorKeys[0]) {
                nestedErrorKeys.shift();
                let nestedErrorStringKey = nestedErrorKeys.join(".");
                this.$set(this.data[dataKey].nestedErrors, nestedErrorStringKey, response.data.errors[errorKey]);
              }
            });
          });

        });
      },
      getFormAttributes() {
        const formAttributes = {};
        for(const attribute of this.data) {
          if (attribute.checkChanged && attribute.value == this.original[attribute.name]) {
            continue;
          }
          formAttributes[attribute.name] = attribute.value;
        }

        return formAttributes;
      },

      buildFormData() {
        if (this.withFiles) {
          const formData = new FormData();

          for(const attribute of this.data) {
            if (attribute.checkChanged && attribute.value == this.original[attribute.name]) {
              continue;
            }
            this.appendFormData(attribute, formData);
          }

          if (this.editing) {
            formData.append("_method", "patch");
          }

          return formData;
        }

        const formData = this.getFormAttributes();
        if (this.editing) {
          formData["_method"] = "patch";
        }

        return formData;
      },
      appendFormData(attribute, formData) {
        if (attribute.value !== null) {
          if (typeof attribute.value === "object" && !(attribute.value instanceof File)) {
            for (let key in attribute.value) {
              this.appendFormData({
                name: attribute.name + "[" + key + "]",
                value: attribute.value[key]
              }, formData);
            }
          } else {
            formData.append(attribute.name, attribute.value);
          }
        }
      },
      component(type){
        return Object.keys(this.$options.components).includes(type) ?
          type : 'InputSelector';
      },
      type(type) {
        return type === undefined ? 'text' : type;
      },
      clearErrors() {
        this.errorMessage = null;
        for(const attribute of this.data) {
          if (attribute.errors.length > 0) {
            attribute.errors = [];
          }

          if (!(Object.entries(attribute.nestedErrors).length === 0 && attribute.nestedErrors.constructor === Object)) {
            attribute.nestedErrors = {};
          }
        }
      },
      hasError({name}) {
        return this.hasErrors && this.errors.errors[name] !== undefined;
      },
      content(model, path) {
        const segments = path.split('|');
        let value = model;
        segments.forEach((segment) => {
          value = value[segment];
        });
        return value;
      },
      updateAttributes() {
        this.data.forEach((element) => {
          if(element.updatable === true){
            this.attributes.forEach((attribute) => {
              if(element.name === attribute.name){
                element.value = attribute.value;
              }
            });
          }
        });
      },
      emitFilterChanged() {
        this.$emit('filter-changed', this.filterAttributes);
        this.$emit('attributes-changed', this.getFormAttributes());
      },
    },
    computed: {
      editing() {
        return this.original !== null && !this.createMode;
      },
      hasErrors() {
        return this.errors !== null;
      },
      createUrl() {
        return this.$store.getters[`${this.resource}/createUrl`];
      },
      filterAttributes() {
        return this.data.filter(attribute => attribute.isFilter);
      },
      colSize() {
        return this.colStyle==="fill" ? 'col-12' : 'col-12 col-md-8';
      }
    },
    watch: {
      attributes : function() {
        this.updateAttributes();
      },
      filterAttributes: {
        handler: function() {
          this.filterChangedDebounced();
        },
        deep: true
      }
    }
  };
</script>
